import { DownloadOutlined } from "@ant-design/icons";
import i18n from "i18next";
import type { FC } from "react";
import { useCallback, useState } from "react";

import { SecondaryButton } from "../Buttons/components/ActionButton";
import { ConfirmationModal } from "../Modal/ConfirmationModal";

export type ExportButtonProps = {
    callback: () => void;
    buttonTextOptional?: string;
};

export const ExportButton: FC<ExportButtonProps> = ({ callback, buttonTextOptional }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);

    const requestUserConfirmation = useCallback(() => {
        setIsModalVisible(true);
    }, [setIsModalVisible]);

    const onOk = useCallback(() => {
        setIsModalVisible(false);
        callback();
    }, [callback, setIsModalVisible]);

    const onCancel = useCallback(() => {
        setIsModalVisible(false);
    }, [setIsModalVisible]);

    return (
        <>
            <ConfirmationModal
                visible={isModalVisible}
                title={i18n.t("genericTable.exportModal.title")}
                onOk={onOk}
                onCancel={onCancel}
                message={i18n.t("genericTable.exportModal.message")}
            />
            <SecondaryButton
                name="export_button"
                onClick={requestUserConfirmation}
                disabled={false}
                icon={buttonTextOptional && <DownloadOutlined />}
            >
                {i18n.t(buttonTextOptional || "button.export")}
            </SecondaryButton>
        </>
    );
};
